export function swiperControlsConfig(root) {
    if (!root) {
        return {
            pagination: false,
            navigation: false,
        }
    }

    const paginationEl = root.querySelector('.swiper-pagination')
    const prevEl = root.querySelector('.swiper-prev')
    const nextEl = root.querySelector('.swiper-next')

    return {
        pagination: paginationEl
            ? {
                  el: paginationEl,
                  clickable: true,
              }
            : false,
        navigation: prevEl && nextEl
            ? {
                  prevEl,
                  nextEl,
              }
            : false,
    }
}
